export enum SuspicionItemEntityType {
  Press = 'press',
  SocialMediaPost = 'SocialAccountPost',
  SocialMediaConnection = 'SocialAccountConnection',
  Image = 'Image',
  GoogleResult = 'WebPage',
  TargetCompany = 'TargetCompany',
}
